module.exports = __webpack_public_path__ + "static/media/ToDoListScreenshot.497599d7.jpg";